import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export function NotFound() {
  const location = useLocation();
  return (
    <Box sx={{ maxWidth: 640, mt: 6 }}>
      <Typography sx={{ fontSize: 20, fontWeight: 800, mb: 1 }}>Nothing here</Typography>
      <Typography color="text.secondary" sx={{ fontSize: 13, mb: 3 }}>
        <code>{location.pathname}</code> is not a screen in this shell. If it is an API path,
        the service serves it directly — see <code>/inventory/docs</code>.
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button size="small" variant="contained" component={RouterLink} to="/items">
          Items
        </Button>
        <Button size="small" variant="outlined" component={RouterLink} to="/diagnostics">
          Diagnostics
        </Button>
      </Stack>
    </Box>
  );
}
